import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const concludeRescuePanelSplit = {
  name: "concludeRescuePanelSplit" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.void(),
};
